// extracted by mini-css-extract-plugin
module.exports = {"msnbcDailyCount":"msnbcDailyCount___3zY0D","inner":"inner___o-D83"};